import { useMutation, useQueryClient } from "@tanstack/react-query";
import authService from "../services/authService";

export function useSignOut() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => authService.signOut(),
    onSuccess: () => {
      // Clear all user-related queries from cache
      queryClient.clear();
    },
  });
}
